module.exports = __webpack_public_path__ + "media/images/alo-moves-73592bea.png";